import map from './map'

export default function unIndexTree(nodes) {
  return map(nodes, (node) => {
    return node.withMutations((n) =>
      n
        .delete('__parentId')
        .delete('__indexGlobal')
        .delete('__indexLocal')
        .delete('__level')
        .delete('__totalChildrenCount')
        .delete('__treeLines'),
    )
  })
}
